

export const groupBy=(array,getGroup)=>{
const groups={};

array.forEach((object,index)=>{
addGroup(object,index,groups,getGroup)
});

return groups
};



const addGroup=(object,index,groups,getGroup)=>{
const groupValue=getGroup(object,index);
const group=String(groupValue);

if(groups[group]===undefined){

groups[group]=[object];
return
}


groups[group].push(object)
};